import gsap from "gsap";
import { scrambleTextAnim } from "./scramble-anim";
import { isMobile, isSafari } from "../utils/variables";

export default function initLink() {
    const links = document.querySelectorAll<HTMLButtonElement>("a.link, button.link");

    links.forEach(link => {
        if (link.classList.contains("link--run")) return;

        const text = link.innerText;
        link.setAttribute("data-text", text);

        if (!isMobile && !isSafari) {
            link.addEventListener("mouseenter", () => {
                scrambleTextAnim(link, link.getAttribute("data-text") || link.innerText);
            });

            link.addEventListener("click", () => {
                gsap.set(link, {
                    text: link.getAttribute("data-text") || link.innerText,
                    width: "auto",
                    overwrite: true,
                });
            });
        }

        link.classList.add("link--run");
    });
}

export function runHeaderLinkAnims() {
    const header = document.querySelector("header");
    if (!header) return;
    const links = header.querySelectorAll<HTMLButtonElement>("a.link, button.link");

    links.forEach(link => {
        scrambleTextAnim(link, link.getAttribute("data-text") || link.innerText);
    });
}
